module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("ASV")]), _vm._v(" "), _c('td', [_vm._v("American Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BDAG")]), _vm._v(" "), _c('td', [_vm._v("Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. "), _c('i', [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(", 3rd ed. Chicago: University of Chicago Press, 2000.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CEB")]), _vm._v(" "), _c('td', [_vm._v("Common English Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ESV")]), _vm._v(" "), _c('td', [_vm._v("English Stanard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KJV")]), _vm._v(" "), _c('td', [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LCL")]), _vm._v(" "), _c('td', [_vm._v("Loeb Classical Library")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LXX")]), _vm._v(" "), _c('td', [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NASB")]), _vm._v(" "), _c('td', [_vm._v("New American Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NET")]), _vm._v(" "), _c('td', [_vm._v("New English Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NET")]), _vm._v(" "), _c('td', [_vm._v("New English Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NETS")]), _vm._v(" "), _c('td', [_vm._v("New English Translation of the Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIV")]), _vm._v(" "), _c('td', [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NLT")]), _vm._v(" "), _c('td', [_vm._v("New Living Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NRSV")]), _vm._v(" "), _c('td', [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RSV")]), _vm._v(" "), _c('td', [_vm._v("Revised Standard Version")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 72
// module chunks = 0